export default __webpack_public_path__ + "static/media/icon_all_intelligences.022e811f.svg";